import { browserApi, type Api } from "./http";

import type { ChatTurn } from "../contracts/envelope.generated";
export type { ChatTurn } from "../contracts/envelope.generated";

export interface ChatHistory {
  turns: ChatTurn[];
  next_cursor: string | null;
}
const path = (runId: string) =>
  `/api/v1/runs/${encodeURIComponent(runId)}/chat`;
export function readChatHistory(
  runId: string,
  before?: string,
  api: Api = browserApi,
) {
  const query = new URLSearchParams({ limit: "30" });
  if (before) query.set("before", before);
  return api.get<ChatHistory>(`${path(runId)}?${query}`);
}
export function sendChat(
  runId: string,
  message: string,
  api: Api = browserApi,
) {
  return api.post<ChatTurn>(path(runId), { message });
}
